/** Do not edit directly **/
/** Do not edit directly **/
/**
 * @prop --sy-progress-spinner-background-color: Background color of the progress spinner background.
 * @prop --sy-progress-spinner-progress-color: Background color of the active part of the progress spinner.
 * @prop --sy-progress-spinner-indeterminate-animation-speed: Indeterminate animation speed of the progress spinner.
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: inline-flex;
  margin: 0;
}

svg {
  transform: scaleY(-1);
}

circle {
  fill: none;
}

.progress-spinner-background {
  stroke: var(--sy-progress-spinner-background-color, var(--sy-surface-dark));
}

.progress-spinner-circle {
  stroke: var(--sy-progress-spinner-progress-color, var(--sy-accent));
}

:host([type=indeterminate]) svg {
  animation: progress-spinner-indeterminate-animation infinite linear;
  animation-duration: var(--sy-progress-spinner-indeterminate-animation-speed, 1s);
}
@keyframes progress-spinner-indeterminate-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}